export default __webpack_public_path__ + "static/media/well-protected-for-seven-months.9dc832a1.svg";